import { getDeviceId } from "./getDeviceId"

export const generateState = (length = 64): string => {
  if (length < 16 || length > 1024) {
    throw new Error("generateState: длина должна быть от 16 до 1024 символов");
  }

  const array = new Uint8Array(length);
  crypto.getRandomValues(array);

  return Array.from(array)
    .map(b => b % 64) // 0–63
    .map(n => "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"[n])
    .join("");
};
/**
 * Формирует URL для редиректа на страницу авторизации Yandex ID
 * @param clientId — ID приложения из Яндекс OAuth
 * @param state — случайная строка для защиты от CSRF (PKCE state)
 * @param redirectUri — куда Яндекс вернёт пользователя после авторизации (по умолчанию — текущий origin)
 * @returns полный URL для редиректа
 */
export const createQueryString = (
  clientId: string,
  state: string,
  redirectUri: string = window.location.origin
): string => {
  if (!clientId?.trim()) {
    throw new Error("clientId обязателен для авторизации Yandex");
  }
  if (!state?.trim()) {
    throw new Error("state обязателен для защиты от CSRF");
  }

  const params = new URLSearchParams({
    response_type: "code",              // обязательный параметр для Authorization Code Flow
    client_id: clientId,
    redirect_uri: redirectUri,
    state: state,
		device_id: getDeviceId(),
    //https://oauth.yandex.ru/authorize?response_type=code&client_id=50cbae39cbc647de8b1cc81197be80a2&scope=login:birthday%20login:email%20login:info
    // Дополнительные полезные параметры (по желанию):
     scope: "login:email login:info login:birthday", // если нужны доп. права
    // display: "popup",                // или "page", "touch" и т.д.
  });

  return `https://oauth.yandex.ru/authorize?${params.toString()}`;
};
